import { _any } from "i18n";
import type {
	DiscoverGameCompetitionEditionResponse,
	DiscoverGameMetadataOptionsResponse,
} from "libs/apiClient";
import type { ReactNode } from "react";
import { Link } from "react-router";

export function gameTypeLabel(
	gameType: string | null,
	gameTypeOptions?: DiscoverGameMetadataOptionsResponse["gameTypes"],
): string {
	if (gameType === null) {
		return "-";
	}

	const translatedLabel = gameTypeOptions?.find((option) => option.value === gameType)?.label;
	if (translatedLabel != null && translatedLabel !== "") {
		return translatedLabel;
	}

	return _any(gameType);
}

export function competitionName(
	competitionEdition: DiscoverGameCompetitionEditionResponse | null | undefined,
): string {
	if (competitionEdition == null) {
		return "-";
	}

	return competitionEdition.competition.name;
}

export function competitionEditionLabel(
	competitionEdition: DiscoverGameCompetitionEditionResponse | null | undefined,
): string {
	if (competitionEdition == null) {
		return "-";
	}

	const parts: string[] = [competitionEdition.season.name];

	if (competitionEdition.groupLabel != null && competitionEdition.groupLabel !== "") {
		parts.push(competitionEdition.groupLabel);
	}

	if (competitionEdition.phaseLabel != null && competitionEdition.phaseLabel !== "") {
		parts.push(competitionEdition.phaseLabel);
	}

	parts.push(`#${competitionEdition.id}`);

	return parts.join(" · ");
}

export function competitionEditionDetailPath(editionId: number): string {
	return `/product-management/competitions/editions/${editionId}`;
}

export function competitionEditionLink(
	competitionEdition: DiscoverGameCompetitionEditionResponse | null | undefined,
): ReactNode {
	if (competitionEdition == null) {
		return "-";
	}

	const label = competitionEditionLabel(competitionEdition);

	return (
		<Link to={competitionEditionDetailPath(competitionEdition.id)} className="button-link">
			{label}
		</Link>
	);
}
